const fieldClasses = (error?: string) =>
  `w-full px-3 text-white bg-panel-middleground border rounded-lg outline-none placeholder:text-dark-tertiary focus:border-primary-blue ${
    error ? "border-dark-disabled" : "border-panel-foreground"
  }`;

const FieldLabel = ({ label }: { label: string }) => (
  <label className="text-sm mobile:text-base text-dark-secondary">
    {label}
  </label>
);

const FieldError = ({ error }: { error?: string }) =>
  error ? <span className="text-sm text-dark-disabled">{error}</span> : null;

export const FormInput = ({
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  onFocus,
  type = "text",
  error,
}: {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  type?: "text" | "email" | "url";
  error?: string;
}) => (
  <div className="flex flex-col gap-y-1 w-full">
    <FieldLabel label={label} />
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      className={`${fieldClasses(error)} py-3`}
    />
    <FieldError error={error} />
  </div>
);

export const FormTextarea = ({
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  maxLength,
}: {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  error?: string;
  maxLength?: number;
}) => (
  <div className="flex flex-col gap-y-1 w-full">
    <FieldLabel label={label} />
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      rows={5}
      maxLength={maxLength}
      className={`${fieldClasses(error)} py-4 resize-none`}
    />
    <FieldError error={error} />
  </div>
);
